<template>
  <v-app light class="no-border">
    <v-content> 
      <v-container fill-height>
          <v-layout row wrap>
          <v-flex xs12>
          </v-flex>
          <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
            <h1 class="display-4 font-weight-black primary--text">403!</h1>
            <p class="headline mt-2">You are not authorized to do this!</p>
            <a class="subheading mt-3" href="/">Go back to Himydata</a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <content-footer></content-footer>
  </v-app>
</template>
<script>
  export default {
  }
</script>